import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { Button } from 'components/ui/button';
import CustomersFunctional from './index.function';
import { ReactSVG } from 'react-svg';
import { add_user_icon, search_icon } from 'asset/icons';
import { fontSizes } from 'appconstants';
import { CustomerTable } from './components';
import ConfirmModal from 'components/ConfirmModal';
import TablePagination from 'components/TablePagination';
import InputField from 'components/InputField';

const Customers = () => {
  const {
    selectedCustomer,
    handleCreate,
    handleEdit,
    deactivateModal,
    setDeactivateModal,
    customers,
    onPageChange,
    page,
    onPressDeactivate,
    onConfirmDeactivate,
    customer_loading,
    search,
    onSearch
  } = CustomersFunctional();

  return (
    <Wrapper className='flex flex-col h-screen'>
      <div className='flex items-center justify-between mb-6'>
        <div>
          <Text text='Manage Customers' className='font-bold' size={fontSizes.h26} />
          <Text text='Control and update customers' className='text-muted-foreground' />
        </div>
        <Button variant='default' className='gap-2' onClick={handleCreate}>
          <ReactSVG src={add_user_icon} /> Add Customer
        </Button>
      </div>

      <div className='flex gap-3 mb-3 md:mb-5'>
        <InputField
          label='Search'
          value={search}
          placeholder={'Search'}
          onChange={onSearch}
          rightIcon={search_icon}
          className='md:w-1/3'
        />
      </div>

      <CustomerTable
        customers={customers?.items}
        onEdit={handleEdit}
        onDeactivate={onPressDeactivate}
      />

      <TablePagination page={page} totalPages={customers?.totalPages ?? 0} onPageChange={onPageChange} />

      <ConfirmModal
        open={deactivateModal}
        title={selectedCustomer?.isActive ? 'Deactivate Customer!' : 'Activate Customer!'}
        description={`Are you sure you want to ${selectedCustomer?.isActive ? 'deactivate' : 'activate'} this customer?`}
        confirmText='Yes'
        cancelText='No'
        onCancel={() => setDeactivateModal(false)}
        onConfirm={() => onConfirmDeactivate()}
        loading={customer_loading}
      />
    </Wrapper>
  );
};

export default Customers;
